module.exports = __webpack_public_path__ + "static/media/icon_close-sm.2f2aa3d0.svg";